export const outboundConversationTransformer = (data) => {
    const { senders } = data;
    const conversationRecipients = [];
    if (senders) {
        Object.entries(senders).forEach(([key]) => {
            const splitKey = key.split('_');
            conversationRecipients.push({
                ID: splitKey[1],
                Class: splitKey[0],
            });
        });
    }
    return JSON.stringify({
        ThreadUsers: conversationRecipients,
    });
};
